import Icon from "../Components/Node_Edge Components/Stencils/Icon";
import Rectangle from "../Components/Node_Edge Components/Stencils/Rectangle";
import Oval from "../Components/Node_Edge Components/Stencils/Oval";
import Diamond from "../Components/Node_Edge Components/Stencils/Diamond";
import Parallelogram from "../Components/Node_Edge Components/Stencils/Parallelogram";
import SubFlowNode from "../Components/Node_Edge Components/Stencils/subflowNode";
import CustomNode from "../Components/Common Components/CustomNode";

const nodeTypes = {
    icon: Icon,
    rectangle: Rectangle,
    oval: Oval,
    diamond: Diamond,
    parallelogram: Parallelogram,
    subflowNode: SubFlowNode,
    customNode: CustomNode,
}

export default nodeTypes;

export const appConstants = {
    clientId: 1 // Rencata Client
}